import { render } from "./CardRaceInfo.vue?vue&type=template&id=625c6225&scoped=true"
import script from "./CardRaceInfo.vue?vue&type=script&lang=js"
export * from "./CardRaceInfo.vue?vue&type=script&lang=js"

import "./CardRaceInfo.vue?vue&type=style&index=0&id=625c6225&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-625c6225"]])

export default __exports__